import React from 'react';
import styled from 'styled-components';
import DoubleIconSvg from '../../stories/assets/double-tick.svg';

const DoubleTiclIcon = styled(DoubleIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1rem'};
  height: ${props => props.height || '.9rem'};
  margin-left: ${props => props.marginleft};
`;

export default DoubleTiclIcon;
